module.exports = __webpack_public_path__ + "img/investment.c4dafea9.svg";